import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './pageTransition.css';
import { Box } from '@mui/material';

const PageTransition = ({ children, trigger, sx }) => {
  const location = useLocation();
  const [animate, setAnimate] = useState(false);

  const runAnimation = () => {
    setAnimate(false);

    setTimeout(() => {
      setAnimate(true);
    }, 30);
  };

  useEffect(() => {
    runAnimation();
  }, [location.pathname]); // route change

  useEffect(() => {
    if (trigger !== undefined) {
      runAnimation();
    }
  }, [trigger]); // same page change

  return (
    <Box
      className={`page-transition ${animate ? 'page-enter' : ''}`}
      sx={{ ...sx }}
    >
      {children}
    </Box>
  );
};

export default PageTransition;
